<template>
  <div id="main">
    <navbar-guest />
    <nuxt id="body" :nuxt-child-key="$route.fullPath" />
    <footer-component />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import NavbarGuest from '~/components/ui/layouts/NavbarGuest.vue';
import FooterComponent from '~/components/Footer.vue';

export default defineComponent({
  components: {
    NavbarGuest,
    FooterComponent
  },
  middleware: ['i18n'],
  data() {
    return {};
  }
});
</script>

<style lang="scss" scoped>
#main {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
}

#body {
  margin-bottom: 100px;
}
</style>
